import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var ScoreBlock = styled.div.withConfig({
  displayName: "ScoreBlock",
  componentId: "sc-1xr23cr-0"
})(["margin:4px auto 12px;"]);
export var ReviewLink = styled(AppLink).withConfig({
  displayName: "ScoreBlock__ReviewLink",
  componentId: "sc-1xr23cr-1"
})(["margin-left:6px;", ";"], maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), getFont(-1)));